export default __webpack_public_path__ + "static/media/321.8913e102.jpg";